export default __webpack_public_path__ + "static/media/terry-dobbie.99e336d1.jpg";